import ajax from '@/config/ajax.js';
import staticDic from './staticDic.js';

const state = {
  ...staticDic,
  _cityTree:[]
}

const getters = {
  getDic(state) {
    return function (type, value) {
      return state[type] ? state[type].reduce((pre, cur) => {
        return cur.value == value ? pre.concat(cur.label) : pre
      }, "") : null
    }
  },
}

const mutations = {
  setCityTree(state, data) {
    state._cityTree = data;
  },
}

const actions = {
  getCityTree({ state, commit }) {
    return new Promise((resolve) => {
      ajax.post("/ipiAreaCode/listData").then(res => {
        if (res.code == 200) {
          let list = res.result
          let data = getTree(list,'province')
          for (let con of data){
            for (let item of list) {
              if (item.province === con.province && item.province !== item.city && item.province !== item.district){
                let obj = Object.assign({},item)
                con.children.push(obj)
              } else if (item.province === con.province && con.province === con.city && item.province !== item.district){
                let obj = Object.assign({},item)
                obj.name = obj.district
                con.children.push(obj)
              }
            }
          }
          for (let item of data) {
            if (item.province !== item.city){
              item.children = getTree(item.children,'city')
            }
          }
          for (let item of data) {
            for(let child of item.children){
              child.children = []
              for (let con of list) {
                if (child.city === con.city && con.province !== con.city && con.city !== con.district){
                  let obj = Object.assign({},con)
                  obj.name = obj.district
                  obj.children = null
                  child.children.push(obj)
                }
              }
              if (child.children.length === 0){
                child.children = null
              }
            }
          }
          commit('setCityTree', data)
        }
        resolve();
      }).catch(err => {
        console.error(err);
      })
    })
  },
}
function getTree(list,name){
  let data = []
  let map = new Map();
  for (let item of list) {
    item.children = []
    item.name = item[name]
    map.set(item[name], item);
  }
  data = [...map.values()];
  return data
}



export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
